import React from "react";
import "./App.css";
import Navbar from "./Components/Navbar";
import FrontPage from './Components/FrontPage'
import Europe from './Components/Continents/Europe'
import Asia from './Components/Continents/Asia'
import America from './Components/Continents/America'
import AboutUs from './Components/AboutUs'
import Contact from './Components/Contact'
import Blog from './Components/Blog'
import Default from './Components/Default'
import Footer from './Components/Footer'
import AirportPickUp from './Components/AdditionalFeaturesDetails/AirportPickUp'
import BetterHotel from './Components/AdditionalFeaturesDetails/BetterHotel'
import MoreTours from './Components/AdditionalFeaturesDetails/MoreTours'

import { Route, Switch } from "react-router-dom";




function App() {
 
  return (
    <div className="">
      <Navbar />
      <Switch>
        <Route exact path='/' component={FrontPage} />
        <Route path='/europe' component={Europe} />
        <Route path='/asia' component={Asia} />
        <Route path='/america' component={America} />
        <Route path='/about-us' component={AboutUs} />
        <Route path='/contact' component={Contact} />
        <Route path='/blog' component={Blog} />
        <Route path='/additional-features/airport-pick-up' component={AirportPickUp} />
        <Route path='/additional-features/hotels' component={BetterHotel} />
        <Route path='/additional-features/more-tours' component={MoreTours} />
        <Route component={Default} />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
